class VgTablet {
	constructor() {
	}

	async init() {
		if (document.querySelector('.vg-gym-tablet-app')) {
			this.gymId = document.querySelector('.vg-gym-tablet-app').getAttribute('data-gym-id');
			this.country = VgHelpers.getCountry();
			this.lang = VgHelpers.getLanguage();
			this.hasOneExperience = false;
			this.currentPage = 0;
			this.currentMenuPage = 0;

			this.vgApiClient = new VgApiClient( this.country, this.lang );
			await this.checkAvailableOptions();
			this.updateTabBarOptions();
			this.addInterestsBehaviors();
			this.addTabBarBehaviors();
			this.showTabBar();
			this.addMobileKeyboardScrollFix();
		}
		if (document.querySelector('.vg-landing-gym__page_overlay')) {
			this.addOverlayBehaviors();
		}

		const params = new URLSearchParams(window.location.search);
		if (params.get('form')) {
			const leadButton = document.querySelector('.vg-gym-tablet-app__nav-menu-item--lead-form a');

			if (leadButton) {
				leadButton.click();
			}
		}
	}

	async checkAvailableOptions() {
		const subscriptionsData = await this.vgApiClient.getSubscriptions(this.gymId, this.country);
		if (null !== subscriptionsData) {
			this.subscriptionsData = subscriptionsData;
			const clipCards = subscriptionsData.clipcards;
			clipCards?.forEach((clipCard) => {
				if (vgHelpersData.global_ids.personalTrainingGlobalId.includes(clipCard.productGroupName)) {
					this.hasOneExperience = true;
				}
			});
		}
		return subscriptionsData;
	}

	renderDayPasses() {
		const container = document.querySelector('.vg-gym-tablet-passes');
		if (!container) return;
		const joiningUrl = container.dataset.joiningUrl;
		const passes = (this.subscriptionsData?.subscriptions ?? [])
			.filter(sub => 'DAY' === sub.periodUnit && 'CASH' === sub.product.type )
			.sort((a, b) => a.periodLength - b.periodLength);
		container.classList.remove('is-loading');
		container.replaceChildren(...passes.map(pass => {
			const a = document.createElement('a');
			a.className = 'vg-gym-tablet__col vg-gym-tablet__bg--secondary-color vg-gym-tablet__rounded vg-gym-tablet__pass-item';
			a.href = `${joiningUrl}&sub=${pass.product.globalId}`;
			const content = document.createElement('div');
			content.className = 'vg-gym-tablet__content';
			const h2 = document.createElement('h2');
			h2.className = 'vg-gym-tablet__content-title';
			h2.textContent = pass.name;
			content.appendChild(h2);
			a.appendChild(content);
			return a;
		}));
	}


	updateTabBarOptions() {
		if (!this.hasOneExperience) {
			document.querySelector('.vg-gym-tablet-app__page--one-experience')?.remove();
			document.querySelector('.vg-gym-tablet-app__nav-menu-item--one-experience')?.remove();
		}
	}

	addInterestsBehaviors() {
		const weights = document.querySelector('.vg-gym-tablet-app__nav-top-weights');
		const menuWeights = document.querySelector('.vg-gym-tablet-app__nav-menu-item--weights').querySelector('a');
		const activities = document.querySelector('.vg-gym-tablet-app__nav-top-activities');
		const menuActivities = document.querySelector('.vg-gym-tablet-app__nav-menu-item--activities').querySelector('a');

		weights.addEventListener('click', (e) => {
			e.preventDefault();
			menuWeights.click();
		});

		activities.addEventListener('click', (e) => {
			e.preventDefault();
			menuActivities.click();
		});
	}

	addTabBarBehaviors() {
		const nextBtn = document.querySelector('.vg-gym-tablet-app__nav-menu-item--next');
		const prevBtn = document.querySelector('.vg-gym-tablet-app__nav-menu-item--prev');
		const menuPages = document.querySelectorAll('.vg-gym-tablet-app__page--menu');
		const pages = document.querySelectorAll('.vg-gym-tablet-app__page');
		const menuLinks = document.querySelectorAll('.vg-gym-tablet-app__nav-menu-item:not(.no-pages) a');

		// Add index to all pages
		let menu_page_index = 0;
		pages.forEach((page, index) => {
			page.setAttribute('data-page', index);
			if ( page.classList.contains('vg-gym-tablet-app__page--menu') ) {
				menu_page_index++;
			}
			page.setAttribute('data-menu-page', menu_page_index);
		});

		// Deactivate prev button on first load
		prevBtn.classList.add('vg-gym-tablet-app__nav-menu-item--disabled');

		// Add links to menu
		menuLinks.forEach((link, index) => {
			link.addEventListener('click', (e) => {
				e.preventDefault();

				// Scroll to page
				menuPages[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
				this.currentPage = menuPages[index].getAttribute('data-page');
				this.currentMenuPage = index + 1;
				this.checkNavButtonState();
				this.checkMenuState();
			})
		});

		// Add links to next and previous buttons
		nextBtn.addEventListener('click', () => {
			if (this.currentPage < pages.length - 1) {
				this.currentPage++;
				pages[this.currentPage].scrollIntoView({ behavior: 'smooth', block: 'start' });
				this.currentMenuPage = pages[this.currentPage].getAttribute('data-menu-page');
				this.checkNavButtonState();
				this.checkMenuState();
			}
		});

		prevBtn.addEventListener('click', () => {
			if (this.currentPage > 0) {
				this.currentPage--;
				pages[this.currentPage].scrollIntoView({ behavior: 'smooth', block: 'start' });
				this.currentMenuPage = pages[this.currentPage].getAttribute('data-menu-page');
				this.checkNavButtonState();
				this.checkMenuState();
			}
		});
	}

	checkNavButtonState() {
		const nextBtn = document.querySelector('.vg-gym-tablet-app__nav-menu-item--next');
		const prevBtn = document.querySelector('.vg-gym-tablet-app__nav-menu-item--prev');
		const pages = document.querySelectorAll('.vg-gym-tablet-app__page');
		const numPages = pages.length;

		if (this.currentPage > 0) {
			prevBtn.classList.remove('vg-gym-tablet-app__nav-menu-item--disabled');
		}
		if (this.currentPage === numPages - 1) {
			nextBtn.classList.add('vg-gym-tablet-app__nav-menu-item--disabled');
		}
		if (this.currentPage < numPages - 1) {
			nextBtn.classList.remove('vg-gym-tablet-app__nav-menu-item--disabled');
		}
		if (this.currentPage === 0) {
			prevBtn.classList.add('vg-gym-tablet-app__nav-menu-item--disabled');
		}
	}

	checkMenuState() {
		const menu_pages = document.querySelectorAll('.vg-gym-tablet-app__nav-menu .vg-gym-tablet-app__nav-menu-item:not(.no-pages');
		document.querySelector('.vg-gym-tablet-app__nav-menu .vg-gym-tablet-app__nav-menu-item.active')?.classList.remove('active');
		menu_pages[this.currentMenuPage - 1]?.classList.add('active');
	}

	showTabBar() {
		const tabBar = document.querySelector('.vg-gym-tablet-app__nav');
		tabBar.style.inset = 'auto 0 0 0';
	}

	hideTabBar() {
		const tabBar = document.querySelector('.vg-gym-tablet-app__nav');
		tabBar.style.inset = tabBar.dataset.originalInset
	}

	addMobileKeyboardScrollFix() {
		const scrollContainer = document.querySelector('.vg-gym-tablet-app');
		if (!scrollContainer) return;
		let savedScrollTop = 0;
		document.addEventListener('focusin', (e) => {
			if (e.target.matches('input, textarea, select')) {
				savedScrollTop = scrollContainer.scrollTop;
			}
		});
		document.addEventListener('focusout', (e) => {
			if (e.target.matches('input, textarea, select')) {
				setTimeout(() => {
					scrollContainer.scrollTop = savedScrollTop;
				}, 100);
			}
		});
	}

	addOverlayBehaviors() {
		const overlays = document.querySelectorAll('.vg-landing-gym__page_overlay');
		const triggers = document.querySelectorAll('.js-tablet-overlay-trigger');
		triggers.forEach((trigger) => {
			const targetId = trigger.getAttribute('data-overlay-target');
			const targetOverlay = document.getElementById(targetId);
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				targetOverlay.classList.add( 'visible' );
				this.showTabBar();
			});
		});
	}

	closeOverlay() {
		document.querySelector('.vg-landing-gym__page_overlay.visible').classList.remove( 'visible' );
		this.hideTabBar();
	}
}

(function () {
	const tabBar = document.querySelector('.vg-gym-tablet-app__nav');
	if (!tabBar) return;
	tabBar.dataset.originalInset = window.getComputedStyle(tabBar).inset;
	document.addEventListener("DOMContentLoaded", () => {
		new VgTablet().init();
	});
})();

(function () {
	const passContainer = document.querySelector('.vg-gym-tablet-passes');
	if (!passContainer) return;
	document.addEventListener('DOMContentLoaded', async () => {
		const tablet = new VgTablet();
		const article = document.querySelector('.vg-gym-tablet');
		tablet.gymId = article.getAttribute('data-gym-id');
		tablet.country = VgHelpers.getCountry();
		tablet.lang = VgHelpers.getLanguage();
		tablet.vgApiClient = new VgApiClient(tablet.country, tablet.lang);
		await tablet.checkAvailableOptions();
		tablet.renderDayPasses();
	});
})();

window.addEventListener('load', function () {
	window.scrollTo(0, 0);
	document.body.style.opacity = 1;
})
